import React from "react";
import ModalBaseView from "../../../../../../common-deprecated/components/modals/aem/ModalBaseView";
import * as Modal from "../../../../../../common-deprecated/styles/v2/lexus/globals/Modal";
import * as Button from "../../../../../../common-deprecated/styles/v2/lexus/components/Button";
import Icon from "../../../../../../common-deprecated/styles/v2/lexus/globals/Icon";
import { IconWrapper } from "../../../../../../common-deprecated/styles/v2/lexus/globals/IconWrapper";
import { type BuildAndBuyLabelType, BnbLabel, getBnbOptionalLabel } from "../../../utils/labels";
import type { ReserveTermsModalType } from "../../../utils/modalConstants";
import { useBnbSelector } from "../../../redux/store";
import type { ModalViewType } from "../../../../../../common-deprecated/types/CommonTypes";

const labelKeys: BuildAndBuyLabelType[] = [
    "reserveTermsConditionsDescription",
    "reserveTermsConditionsScroll1",
    "reserveTermsConditionsScroll2",
    "reserveTermsConditionsExtra",
];

const monthlyLabelKeys: BuildAndBuyLabelType[] = [
    "reserveTermsConditionsDescriptionMonthly",
    "reserveTermsConditionsScroll1Monthly",
    "reserveTermsConditionsScroll2Monthly",
    "reserveTermsConditionsExtraMonthly",
];

const ReserveTermsModal = (props: ModalViewType<ReserveTermsModalType>): JSX.Element => {
    const { show, close, modalSettings } = props;
    const financeOption = useBnbSelector((state) => state.utils.financeOption);
    const bnbSettings = useBnbSelector((state) => state.bnbSettings);
    const commonSettings = useBnbSelector((state) => state.commonSettings);

    return (
        <ModalBaseView modalIdType={modalSettings.type} onClose={close} show={show} size="md">
            <Modal.Header>
                <Modal.Title>
                    <BnbLabel
                        fallbackLabel="reserveTermsConditionsTitle"
                        label={
                            financeOption === "cash"
                                ? "reserveTermsConditionsTitle"
                                : "reserveTermsConditionsTitleMonthly"
                        }
                    />
                </Modal.Title>
                <Modal.Button type="button" onClick={close}>
                    <IconWrapper>
                        <Icon variant="close" />
                    </IconWrapper>
                </Modal.Button>
            </Modal.Header>
            <Modal.Body>
                {labelKeys.map(
                    (key, index) =>
                        !!getBnbOptionalLabel({ bnbSettings, commonSettings }, key) && (
                            <div key={key}>
                                <BnbLabel
                                    fallbackLabel={key}
                                    label={financeOption === "cash" ? key : monthlyLabelKeys[index]}
                                    useHTML
                                />
                            </div>
                        ),
                )}
            </Modal.Body>
            <Modal.Actions>
                <Button.Primary type="button" onClick={close}>
                    <BnbLabel
                        fallbackLabel="reserveTermsConditionsOk"
                        label={
                            financeOption === "cash" ? "reserveTermsConditionsOk" : "reserveTermsConditionsOkMonthly"
                        }
                    />
                </Button.Primary>
            </Modal.Actions>
        </ModalBaseView>
    );
};

export default ReserveTermsModal;
